import Reveal from "./Reveal";

const DIMENSIONS = [
  {
    num: "01",
    label: "01 · Tax",
    title: "One tax plan across every country the family touches",
    body: "Income, capital gains, exit and inheritance events, mapped for each family member and each jurisdiction, so that a decision in one country does not create a bill in another.",
  },
  {
    num: "02",
    label: "02 · Residency and citizenship",
    title: "Where the family lives, and what that does to everything else",
    body: "Residency and citizenship options for each member, weighed for their tax effect, their reporting burden and the choices they open or close for the children.",
  },
  {
    num: "03",
    label: "03 · Banking",
    title: "Banks and custodians that say yes the first time",
    body: "Selection, introductions and onboarding files prepared to the standard compliance teams expect, for the operating entities, the holding structure and the family itself.",
  },
  {
    num: "04",
    label: "04 · Asset protection",
    title: "Trusts, foundations and holding vehicles that agree with each other",
    body: "Estate and protection structures designed as one system, with wills in each relevant country that reinforce rather than contradict the structure above them.",
  },
  {
    num: "05",
    label: "05 · Business structuring",
    title: "The holding, the entities beneath it, and why each exists",
    body: "Where the office sits, how operating companies and investments are held, and how cash moves between them. Every entity has a stated purpose or it is not in the plan.",
  },
  {
    num: "06",
    label: "06 · Family and lifestyle",
    title: "Governance the family will use",
    body: "A family charter, decision rights, an investment policy and a succession sequence, written plainly enough that a twenty five year old can pick them up and follow them.",
  },
];

export default function Scope() {
  return (
    <section className="band band-deep" id="scope" data-testid="section-scope">
      <div className="container">
        <Reveal>
          <div className="section-head">
            <p className="eyebrow">What we set up</p>
            <div>
              <h2>The whole office, across all seven dimensions.</h2>
              <p className="lede">
                Every family office we build is designed across the same seven
                dimensions we use for every client of the firm. The difference
                here is scope: we design the full structure, then coordinate
                every professional needed to build it.
              </p>
            </div>
          </div>
        </Reveal>
        <div className="scope-grid" data-testid="scope-grid">
          {DIMENSIONS.map((dimension, index) => (
            <Reveal key={dimension.num} delay={index * 0.05}>
              <article
                className="scope-card"
                data-testid={`scope-card-${dimension.num}`}
              >
                <p className="card-label">{dimension.label}</p>
                <h3>{dimension.title}</h3>
                <p>{dimension.body}</p>
              </article>
            </Reveal>
          ))}
          <Reveal
            className="scope-card scope-card-wide"
            data-testid="scope-card-07"
          >
            <div>
              <p className="card-label">07 · Implementation</p>
              <h3>We build it, and we hold the timetable</h3>
            </div>
            <div>
              <p>
                Once the design is agreed we brief the lawyers, accountants,
                banks and fiduciaries in each country, review their work
                against the plan and keep the whole sequence on schedule. You
                have one point of accountability instead of six invoices and
                no coordinator. We also settle the operating model: whether
                the office hires, outsources or stays lean, and how reporting
                and consolidation will work from day one.
              </p>
              <ul className="scope-list">
                <li>
                  Lawyers, accountants and fiduciaries selected and briefed by
                  us
                </li>
                <li>
                  Their work reviewed against the plan before you sign
                  anything
                </li>
                <li>
                  Filings made by the licensed professional in each country,
                  never by us directly
                </li>
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
